
import { useOktaAuth, LoginCallback } from '@okta/okta-react';
import CommToolProvider from '../../containers/common/comm_tool_provider';
import HeaderNav from '../../containers/HeaderNav/navigation';
import BrowserDetection from 'react-browser-detection';
import React, { useEffect } from 'react';
import { getUserProfile } from '../../api';
import { setGlobalAuth } from 'utils/UserInfo';

const localBrowserHandler = {
    ie: () => (
      <div className='ieWarning'>
        WARNING: Some Checklist App functionality is unavailable in Internet Explorer.
      </div>
    ),
    default: () => <div />,
  };
const AuthenticationWrapper = (props) => {
    const { authState, oktaAuth } = useOktaAuth();

    useEffect(() => {
        if (authState?.isAuthenticated) {
            const token = authState.accessToken.accessToken;
            if(token){
                //document.cookie = `aep=${token}; path=/; secure; samesite=strict`;
            }
            getUserProfile(); 
        }else{
                document.cookie = "aep=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
    }, [authState]);

        useEffect(() => {
            if (authState) {
                setGlobalAuth(authState);
            }
        }, [authState]);

    if (!authState || authState.isPending) {
        return <div>Loading authentication...</div>;
    }

    if (!authState.isAuthenticated) {
        oktaAuth.signInWithRedirect({ originalUri: window.location.pathname });
        return <div>Redirecting...</div>;
    }

    return (
        <>
            <BrowserDetection>
            {localBrowserHandler}
            </BrowserDetection>
            <HeaderNav />
           <div className="app-content">
    {props.children}
</div>
        </>
    );
};
export default AuthenticationWrapper;